<template>
  <div class="modal fade" id="cameraModal" tabindex="-1" aria-hidden="true" ref="modal">
    <div class="modal-dialog modal-dialog-centered modal-md camera-modal">
      <div class="modal-content">
        <!-- HEADER -->
        <div class="modal-header py-2">
          <h6 class="modal-title mb-0">Camera Capture</h6>
          <button type="button" class="btn-close" aria-label="Close" @click="closeModal"></button>
        </div>
        <!-- BODY -->
        <div class="modal-body p-0">
          <div class="camera-stage">
              <!-- Live Camera -->
              <video v-show="!photoData"
                ref="video" autoplay playsinline muted
                class="camera-preview">
              </video>
              <!-- Captured Photo -->
              <img v-if="photoData"
                :src="photoData" class="captured-img" alt="Captured"
              />
          </div>
        </div>
        <!-- FOOTER -->
        <div class="modal-footer camera-footer">
        <template v-if="!photoData">
          <button class="shutter-btn" @click="capturePhoto">
            <span class="shutter-inner">
              <i class="bi bi-camera-fill"></i>
            </span> 
            </button>
        </template>
        <template v-else>
          <button class="btn btn-outline-secondary" @click="retake">
            <i class="bi bi-arrow-repeat"></i> Retake
          </button>
          <button class="btn btn-success" @click="confirmPhoto">
            <i class="bi bi-check-circle"></i> Use Photo
          </button>
        </template>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as bootstrap from "bootstrap";
export default {
  name: "CameraCapture",
  emits: ["captured"],
  data() {
    return {
      stream: null,
      photoData: null,
      bsModal: null
    };
  },
  methods: {
    async openModal() {
      await this.startCamera();
      this.bsModal = new bootstrap.Modal(this.$refs.modal, {
        backdrop: "static",
        keyboard: false
      });
      this.bsModal.show();
    },
    async startCamera() {
      try {
        if (!window.isSecureContext) {
          alert("Camera access requires a secure context.");
          return;
        }
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" }
        });
        this.$refs.video.srcObject = this.stream;
      } catch (err) {
        alert("Camera access denied or unavailable.");
      }
    },
    capturePhoto() {
      const video = this.$refs.video;
      if (!video || video.videoWidth === 0) {
        alert("Camera not ready");
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1); // mirror
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.photoData = canvas.toDataURL("image/jpeg", 0.9);
    },
    retake() {
      this.photoData = null;
    },
    confirmPhoto() {
      this.$emit("captured", this.photoData);
      this.closeModal();
    },
    closeModal() {
      if (this.bsModal) this.bsModal.hide();
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
      this.photoData = null;
    }
  }
};
</script>
<style scoped>
/* Modal sizing */
.modal-body {
  width: 100%;
  background: black;
  display: flex;
}
.camera-modal {
  max-width: 80vw;
}
.camera-stage {
  width: 100%;
  max-height: 70vh;
  aspect-ratio: 3 / 4;
  margin: 0 auto;
  background: linear-gradient(90deg, #000 0%, #111 50%, #000 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
/* Camera preview */
.camera-preview,
.captured-img {
  width: 100%;
  height:100%;
  border-radius: 10px;
  object-fit: contain;
  box-shadow: 0 0 12px rgba(0,0,0,0.35);
  background: black;
}
.camera-preview {
  transform: scaleX(-1);
}
/* Captured image border */
/* Footer layout */
.camera-footer {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0.2rem;
}
/* Shutter button */
.shutter-btn {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  transition: transform 0.15s ease;
}
/* Inner ring */
.shutter-inner {
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e5e5e5;
}
/* Camera icon */
.shutter-inner i {
  font-size: 22px;
  color: #000;
}
/* Tap animation */
.shutter-btn:active {
  transform: scale(0.95);
}
@media (max-width: 576px) {
  .camera-modal {
    max-width: 100vw;
    margin: 0;
  }
  .modal-content {
    height: 100vh;
    border-radius: 0;
  }
  .camera-preview,
  .captured-img {
    max-height: 75vh;
  }
}
</style>